export class UploadableFile {
  constructor(file) {
    this.file = file;
    this.id = `${file.name}-${file.size}-${file.lastModified}-${file.type}`;
    this.name = file.name;
    this.size = file.size;
    this.type = file.type;
  }
}
